import { ThemeColor, ThemeColors } from 'styled-components';

/**
 * Helper function to get color value from theme colors if it exists, and if not use the color
 *
 * @param color - could be a color name from our theme colors, or a hex/rgb value or a color string
 * @param themeColors - object containing all the theme colors
 * @returns color value to render
 */
export const getColor = (color: string, themeColors: ThemeColors) => {
  return themeColors.hasOwnProperty(color)
    ? themeColors[color as ThemeColor]
    : color;
};
